import { Font, StyleSheet } from '@react-pdf/renderer';

export enum COLOR {
  primary = '#3B92AE',
  primaryActive = '#43A9CA',
  white = '#FFFFFF',
  offWhite = '#F6F6F6',
  lightGray = '#CCCCCC',
  mediumGray = '#666666',
  hoverGray = '#0000000a',
  lightRed = '#E85F5F',
  lightOrange = '#e8a35f',
  classificationMinorLight = '#e4e4e4',
}

export enum FONT_SIZE {
  tiny = '11px',
  small = '12px',
  medium = '14px',
  large = '16px',
  big = '18px',
  huge = '22px',
}

export enum BORDER_RADIUS {
  small = '5px',
  medium = '17px',
  leftRoundedOnly = '5px 0 0 5px',
  rightRoundedOnly = '0 5px 5px 0',
}

export enum MARGIN {
  tiny = '1px',
  small = '2px',
  medium = '5px',
  large = '10px',
  selectedCapsule = `0 0 0 5px`,
}

Font.register({
  family: 'Open Sans',
  fonts: [
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf',
    },
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
      fontWeight: 600,
    },
  ],
});

const styles = StyleSheet.create({
  flex: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    flexDirection: 'column',
  },
  flexOne: {
    flexGrow: 1,
  },
  flexCenterH: {
    justifyContent: 'center',
  },
  flexCenterV: {
    alignItems: 'center',
  },
  spaced: {
    gap: MARGIN.medium,
  },
  spacedLarge: {
    gap: MARGIN.large,
  },
  bold: {
    fontWeight: 600,
  },
  bullet: {
    fontSize: 12,
    fontWeight: 600,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap: MARGIN.large,
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  accordionHeader: {
    backgroundColor: COLOR.primary,
    color: COLOR.white,
    padding: MARGIN.medium,
    borderTopLeftRadius: BORDER_RADIUS.small,
    borderTopRightRadius: BORDER_RADIUS.small,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    fontWeight: 600,
  },
  accordionContent: {
    borderWidth: 1,
    borderColor: COLOR.lightGray,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: BORDER_RADIUS.small,
    borderBottomLeftRadius: BORDER_RADIUS.small,
    borderTop: 0,
    padding: MARGIN.medium,
  },
  titleBar: {
    backgroundColor: COLOR.classificationMinorLight,
    borderRadius: BORDER_RADIUS.small,
    padding: MARGIN.medium,
    color: COLOR.mediumGray,
    fontSize: FONT_SIZE.small,
    alignItems: 'center',
  },
  image: {
    maxWidth: 140,
  },
  imageHSE: {
    width: 150,
  },
  link: {
    color: COLOR.primaryActive,
  },
  page: {
    flexDirection: 'column',
    gap: MARGIN.medium,
    padding: 20,
    color: COLOR.mediumGray,
    fontSize: 8,
    fontFamily: 'Open Sans',
  },
  horizontalSeparator: {
    display: 'flex',
    alignSelf: 'center',
    borderTop: `1px solid ${COLOR.lightGray}`,
    width: '100%',
    height: 1,
  },
  verticalSeparator: {
    borderWidth: 1,
    borderColor: COLOR.lightGray,
    height: 'auto',
  },
  section: {
    marginBottom: MARGIN.large,
  },
  reportDetailHeader: {
    fontWeight: 700,
  },
  reportDetailContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: MARGIN.large,
  },
  optionWithCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  otherText: {
    backgroundColor: COLOR.offWhite,
    border: 1,
    borderColor: COLOR.lightGray,
    width: '90%',
    borderRadius: BORDER_RADIUS.small,
    padding: 4,
    marginRight: '10%',
  },
  edmsText: {
    backgroundColor: COLOR.offWhite,
    border: 1,
    borderColor: COLOR.lightGray,
    width: '100%',
    borderRadius: BORDER_RADIUS.small,
    padding: 4,
    marginRight: '0%',
  },
  label: {
    fontWeight: 400,
  },
  inputText: {
    backgroundColor: COLOR.offWhite,
    border: 1,
    borderColor: COLOR.lightGray,
    width: '100%',
    borderRadius: BORDER_RADIUS.small,
    padding: 4,
    marginRight: '0%',
  },
  choiceInputContainer: {
    marginBottom: 8,
  },
  choiceGroup: {
    flexDirection: 'row',
  },
  choiceItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 12,
    gap: 2,
  },
  choiceLabel: {
    marginRight: 4,
  },
  lightGray: {
    color: COLOR.lightGray,
  },
  mediumGray: {
    color: COLOR.mediumGray,
  },
  accordianSubTitle: {
    marginBottom: 6,
    fontWeight: 700,
    fontSize: FONT_SIZE.small,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'dashed',
  },
  thinRoundBorder: {
    border: 1,
    borderColor: COLOR.lightGray,
    borderRadius: BORDER_RADIUS.small,
    padding: 4,
    marginBottom: 4,
  },
  miniMarginButtom: {
    marginBottom: 4,
  },
});

export default styles;
